import { SVG } from '../svg';
import { IconProps } from '../types';

export function ChevronDownIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="m6 9 6 6 6-6" />
    </SVG>
  );
}
